import Phaser, { Tweens } from "phaser";
import { PhaserGameObject } from "./Types";

type ShakeOptions = {
  duration?: number;
  magnitude?: number;
  rotate?: boolean;
  restore?: boolean;
};

export function Shake(
  scene: Phaser.Scene,
  target: Phaser.GameObjects.Components.Transform,
  {
    duration = 250,
    magnitude = 8,
    rotate = false,
    restore = true,
  }: ShakeOptions = {},
): Tweens.Tween {
  const startX = (target as PhaserGameObject).x as number;
  const startY = (target as PhaserGameObject).y as number;
  const startRot = (target as PhaserGameObject).rotation as number;

  return scene.tweens.addCounter({
    from: 0,
    to: 1,
    duration,
    ease: "Sine.easeOut",
    onUpdate: (tw) => {
      const p = tw.progress;
      const damp = 1 - p;
      const max = magnitude * damp;

      const offsetX = Phaser.Math.FloatBetween(-max, max);
      const offsetY = Phaser.Math.FloatBetween(-max, max);
      (target as PhaserGameObject).x = startX + offsetX;
      (target as PhaserGameObject).y = startY + offsetY;

      if (rotate) {
        const maxRot = (max / 60) * Math.PI;
        (target as PhaserGameObject).rotation =
          startRot + Phaser.Math.FloatBetween(-maxRot, maxRot);
      }
    },
    onComplete: () => {
      if (restore) {
        (target as PhaserGameObject).x = startX;
        (target as PhaserGameObject).y = startY;
        if (rotate) (target as PhaserGameObject).rotation = startRot;
      }
    },
  });
}
